import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=ac6f1914&scoped=true&"
import script from "./SButton.vue?vue&type=script&lang=js&"
export * from "./SButton.vue?vue&type=script&lang=js&"
import style0 from "./SButton.vue?vue&type=style&index=0&id=ac6f1914&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6f1914",
  null
  
)

export default component.exports